<nav [class.mobile]="mobile$ | async">
  @for (app of allowedApps$ | async; track $index){
    <button (click)="clickedItem.emit()" routerLink="/apps/{{ app.apiRoute }}" routerLinkActive="active">
      <div class="link-with-icon">
          <i class="fa {{ app.icon }}"></i>
          <span>{{ app.localizedName }}</span>
      </div>
    </button>
  }
  
  @if (authenticationService.isImpersonating() ){
    <button (click)="stopImpersonating(); clickedItem.emit()">
      <div class="link-with-icon">
        <i class="fa-solid fa-user-secret"></i>
        <div class="with-subtext">
          <span i18n="@@StopImpersonationButton">Stop Impersonating</span>
          <span i18n="@@StopImpersonationSubtext">User: {{ impersonatingEmail }}</span>
        </div>
      </div>
    </button>
  }
</nav>